export * from './term-dialog/term-dialog.component';
export * from './term-dialog-content/term-dialog-content.component';
export * from './terms-and-conditions.module';
